<template>
  <div ref="popup" v-if="isOn" class="dropdown-menu show" :style="getOffsetStyles()" v-click-outside="off">
    <slot />
  </div>
</template>

<script>
import vClickOutside from "click-outside-vue3";

export default {
  name: "MiniPopup",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  // show - for data manipulation before render. shown - for access to the rendered popup
  emits: ["show", "hide", "shown"],
  data() {
    return {
      pad: 30,
      isOn: false,
    }
  },
  props: {
    // the tools menu moving back into the window makes the window flash with a scrollbar for a second. This avoids having to move the window automatically
    offsetX: {
      required: false,
      default: 0,
    },
    offsetY: {
      required: false,
      default: 0,
    },
  },
  methods: {
    off() {
      this.isOn = false;
      this.$emit("hide");
    },
    on() {
      this.isOn = true;
      window.setTimeout(() => {
        this.keepInWindow();
        this.$emit("shown");
      }, 0);
      this.$emit("show");
    },
    toggle() {
      this.isOn ? this.off() : this.on();
    },
    keepInWindow() {
      const el = this.$refs.popup;
      const bounds = el.getBoundingClientRect();

      const windowLeft = this.pad;
      const windowRight = window.innerWidth - this.pad;
      const windowTop = this.pad;
      const windowBottom = window.innerHeight - this.pad;

      const left = bounds.left;
      const right = bounds.right;
      const top = bounds.top;
      const bottom = bounds.bottom;

      const fixX = left < windowLeft ? windowLeft - left : right > windowRight ? windowRight - right : null;
      const fixY = top < windowTop ? windowTop - top : bottom > windowBottom ? windowBottom - bottom : null;

      if (fixX != null) {
        el.style.left = (el.offsetLeft + fixX) + 'px';
      }
      if (fixY != null) {
        el.style.top = (el.offsetTop + fixY) + 'px';
      }
    },
    getOffsetStyles() {
      if (!this.offsetX && !this.offsetY) {
        return {};
      }

      return { transform: `translate(${this.offsetX}px, ${this.offsetY}px)` };
    },
    handleKeydown(e) {
      if (e.key === "Escape") {
        this.off();
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  unmounted() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
  z-index: var(--z-popup);
  box-shadow: 0px 2px 7px var(--popup-shadow-color);
  font-size: 14px;
}

:slotted(.dropdown-item.has-submenu) {
  display: flex;
  justify-content: space-between;  

  &:after {
    content: "";
    display: inline-block;
    border-bottom: 0;
    border-left: .3em solid transparent;
    border-right: .3em solid transparent;
    border-top: .3em solid;
    margin-left: .255em;
    vertical-align: .255em;
    transform: rotate(270deg) translate(0px, 10px);
  }
}

</style>
